import React from 'react';
import PropTypes from 'prop-types';
import { Toast } from '@pearsontechnology/aero-components-learnspace';
import styled from 'styled-components';
import ToastManager from 'ToastManager';

const ToastWrapper = styled.div`
  position: fixed;
  display: flex;
  bottom: 14px;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  /* transform-origin-x: 50%; */

  min-width: 260px;
  max-width: 320px;
`;

const ToastItem = styled.div`
  padding: 10px 38px;
  display: block;
  width: auto;
`;

class ToastContainer extends React.Component {
  state = {
    toasts: [],
  }

  componentDidMount() {
    ToastManager.registerListener(this.onNotify);
  }

  removeItem = (toast) => {
    const { toasts } = this.state;
    const index = toasts.indexOf(toast);
    if (index === -1) {
      return;
    }

    const newToasts = [...toasts];
    newToasts.splice(index, 1);
    this.setState({ toasts: newToasts });
  }

  onNotify = (toast) => {
    const { toasts } = this.state;
    toasts.push(toast);
    this.setState({ toasts });

    if (!(toast.waitForAction && toast.actions && toast.actions.length > 0)) {
      setTimeout(() => this.removeItem(toast), 3000);
    }
  }

  render() {
    const { children } = this.props;
    const { toasts } = this.state;
    return (
      <div>
        { children }

        <ToastWrapper>
          { toasts && toasts.map(({ message, actions }, index) => (
            <ToastItem>
              <Toast
                key={`toast-${index.toString()}`}
                message={message}
                actions={actions}
                onApplyAction={() => this.removeItem(toasts[index])}
              />
            </ToastItem>
          ))}
        </ToastWrapper>
      </div>
    );
  }
}

ToastContainer.propTypes = {
  children: PropTypes.any,
};

export default ToastContainer;
